/** Nth path segment after "counselling" (0 = first, 1 = second, e.g. bristol/anxiety). */
export const segmentAtCounselling = (path, index = 0) => {
  if (!path || typeof path !== "string") return null;
  const clean = path.split("?")[0].split("#")[0];
  const parts = clean.split("/").filter(Boolean);
  const idx = parts.indexOf("counselling");
  if (idx === -1 || idx + 1 + index >= parts.length) return null;
  const slug = parts[idx + 1 + index];
  return slug && slug.trim() ? slug.trim() : null;
};

const toTitleCase = (value) => {
  if (typeof value !== "string" || !value.trim()) return null;
  return value
    .toLowerCase()
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

/**
 * @param {{ location?: string | null, topic?: string | null }} params
 * Display names (already title-cased), not URL slugs.
 */
export function buildCounsellingMeta({ location = null, topic = null } = {}) {
  const locationLabel =
    typeof location === "string" && location.trim() ? location.trim() : null;
  const topicLabel =
    typeof topic === "string" && topic.trim() ? topic.trim() : null;

  if (locationLabel && topicLabel) {
    return {
      title: `Counselling for ${topicLabel} - ${locationLabel} - Find a Therapist Near You`,
      description: `Local ${topicLabel} Counselling Services - Find a Therapist Near ${locationLabel}`,
    };
  }

  if (locationLabel) {
    return {
      title: `Counselling - ${locationLabel} - Find a Therapist Near You`,
      description: `Local Counselling Services - Find a Therapist Near ${locationLabel}`,
    };
  }

  if (topicLabel) {
    return {
      title: `Counselling for ${topicLabel} - Find a Therapist Near You`,
      description: `Local ${topicLabel} Counselling Services - Find a Therapist Near You`,
    };
  }

  return {
    title: "Local Counselling Services - Find a Therapist Near You",
    description: "Local Counselling Services - Find a Therapist Near You",
  };
}

export const GENERIC_COUNSELLING_META = buildCounsellingMeta();

export const isGenericCounsellingMeta = (meta) =>
  meta?.title === GENERIC_COUNSELLING_META.title;

/**
 * Build meta from getStaticProps search state (stable for SSR / crawlers).
 * @param {object} search
 * @param {string} canonicalPath
 */
export function getCounsellingMetaFromSearch(
  search = {},
  canonicalPath = "/counselling",
) {
  let locationForMeta = search.location?.place
    ? toTitleCase(search.location.place)
    : search.location?.outcode
      ? String(search.location.outcode).toUpperCase()
      : null;
  let topicForMeta = search.modality ? toTitleCase(search.modality) : null;

  if (!topicForMeta) {
    const topicSlug = segmentAtCounselling(canonicalPath, 1);
    if (topicSlug) topicForMeta = toTitleCase(topicSlug);
  }

  // Do not treat the first URL segment as a location on modality-only pages.
  if (!locationForMeta && !search.modality) {
    const locationSlug = segmentAtCounselling(canonicalPath, 0);
    if (locationSlug) locationForMeta = toTitleCase(locationSlug);
  }

  return buildCounsellingMeta({
    location: locationForMeta,
    topic: topicForMeta,
  });
}

export { toTitleCase };
